import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import { DEFAULT_FILTERS } from '../buildCorporateBondScreenerRequest';

const toDraftDate = (value: unknown): string | null => (typeof value === 'string' ? value.slice(0, 10) : null);

export const mapViewFiltersToDraft = (viewFilters: Partial<TFilterPayload> | null): TFilterPayload => {
  const merged = { ...DEFAULT_FILTERS, ...viewFilters };

  return {
    ...merged,
    dateFrom: toDraftDate(viewFilters?.dateFrom) ?? DEFAULT_FILTERS.dateFrom,
    dateTo: toDraftDate(viewFilters?.dateTo) ?? DEFAULT_FILTERS.dateTo,
    includedMaturityDateFrom: toDraftDate(viewFilters?.includedMaturityDateFrom)
      ?? DEFAULT_FILTERS.includedMaturityDateFrom,
    includedMaturityDateTo: toDraftDate(viewFilters?.includedMaturityDateTo)
      ?? DEFAULT_FILTERS.includedMaturityDateTo,
    includedCallDateFrom: toDraftDate(viewFilters?.includedCallDateFrom) ?? DEFAULT_FILTERS.includedCallDateFrom,
    includedCallDateTo: toDraftDate(viewFilters?.includedCallDateTo) ?? DEFAULT_FILTERS.includedCallDateTo,
  };
};
